export default {
    baseUrl: 'https://staging.lexination.com',
    dateFormat: 'MMM. DD, YYYY',
    dateLongFormat: 'MMM. DD, YYYY hh:mm a',
}